import styled from 'types/theme.types';

export const SwitcherContainer = styled.div`
  background: var(--surface-main-cards);
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  box-shadow: var(--shadow-dropdown);
  overflow: hidden;
`;
